import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import '../assets/css/Contact.css';
import { baseurl } from "../utility/helper";

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <button className="slick-prev" onClick={onClick}>
      Previous
    </button>
  );
}

function NextArrow(props) {
  const { onClick } = props;
  return (
    <button className="slick-next" onClick={onClick}>
      Next
    </button>
  );
}

const Contact = () => {
  const [contacts,setContacts] = useState([]);
  const Member_count = sessionStorage.getItem("members_in_india");

  useEffect(()=>{
  fetchContacts();
  },[]);

  const fetchContacts = async () => {
  const res = await axios.get(`${baseurl}/contacts`);
  setContacts(res.data);
  };

  const groupedContacts = contacts.reduce((acc, contact) => {
    if (!acc[contact.contact_type]) {
      acc[contact.contact_type] = [];
    }
    acc[contact.contact_type].push(contact);
    return acc;
  }, {});

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (

<div className='bacimage'>
<section className="banner">
  <Slider {...settings}>

    {/* Slide 1 - Clean Image */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Banner 1" />
       <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

    {/* Slide 2 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner3.png" alt="Social Impact" />
      <div className="hero-content">
        <h1 className="hero-title">
          SOCIAL IMPACT
          <br />
          DHRUV &amp; TMNP
        </h1>
       
        <div className="hero-actions">
          <NavLink to="/Spotlight" className="hero-btn hero-btn--primary"> Click Here</NavLink>
        </div>
      </div>
    </div>

    {/* Slide 3 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Our Mission" />
      <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

  </Slider>
</section>

<div className="container" style={{ maxWidth: "1200px", margin: "auto", marginTop: "50px" }}>
  <h2>Contact Us:</h2>

  <p>
    <strong>For Membership Related Queries, Special Interest Groups, Events:</strong><br />
    Please contact the Chapter Head of your nearest chapter. In case you are a visiting Mensan, please contact 
    <span style={{ color: "green", fontWeight: "bold" }}><a href="mailto:SIGHT@mensaindia.org" style={{fontWeight: "bold", color: "green" }}> SIGHT@mensaindia.org</a></span>.
  </p>

  <p>
    <strong>For Testing Schedule and any other queries:</strong><br />
    Please contact 
    <span style={{ color: "green", fontWeight: "bold" }}><a href="mailto:mensahq@mensaindia.org" style={{color: "green", fontWeight: "bold" }}> mensahq@mensaindia.org</a></span>.
  </p>

  <p>
    <strong>Underprivileged Gifted Child Identification & Nurturing Programme:</strong><br />
    Please contact Dr. Narayan Desai (Pune) or Ms Shilpa Kulkarni on email id 
    <span style={{ color: "green", fontWeight: "bold" }}><a href="mailto:TMNP@mensaindia.org" style={{color: "green", fontWeight: "bold" }}> TMNP@mensaindia.org </a></span> 
    for Mensa India’s Tribal Mensa Nurturing Program and Apoorva Tiwari on email id 
    <span style={{ color: "green", fontWeight: "bold" }}><a href="mailto:apoorva@mensaprojectdhruv.in" style={{color: "green", fontWeight: "bold" }}> apoorva@mensaprojectdhruv.in </a></span> 
    for Mensa India’s Project Dhruv.
  </p>
</div>

    {Object.keys(groupedContacts).map((type) => (
  <div className="container" style={{marginTop:'40px'}} key={type}>

    <div className="row">
      <div className="col-md-12">
        <h5 style={{textAlign:'center'}}>{type.toUpperCase()}</h5>
      </div>
    </div>

    <div className="row">

      {groupedContacts[type].map((item) => (

        <div className="col-xl-3 col-sm-6" key={item.id}>
          <div className="card">
            <div className="card-body">

              <div className="d-flex align-items-center">

                <div className="flex-1 ms-3">
                  <h8 className="font-size-16 mb-1">
                    <a href="#" className="text-dark">{item.contact_name}</a>
                  </h8>

                  <span className="badge badge-soft-success mb-0">
                    {item.designation}
                  </span>
                </div>

                <div style={{display:'contents'}}>
                  <img
                    src={item.contact_image}
                    alt={item.contact_name}
                    className="avatar-md rounded-circle img-thumbnail"
                  />
                </div>

              </div>

            </div>
          </div>
        </div>

      ))}

    </div>
  </div>
))}


    </div>
  );
};



export default Contact;
